var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-size-control",class:[("text-" + _vm.size), { selected: _vm.selected }],on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', _vm.size)}}},[_vm._v("Αα")])}
var staticRenderFns = []

export { render, staticRenderFns }